var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalLearnersCountIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4437_7236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 24.75H36C33.5138 24.75 31.5 22.7362 31.5 20.25V17.2507C31.5 13.9365 34.1865 11.25 37.5007 11.25H45C46.656 11.25 47.9993 12.5933 47.9993 14.2493C48.8272 14.2493 49.5 14.922 49.5 15.75V20.25C49.5 22.7362 47.4862 24.75 45 24.75Z",
    fill: "#A36229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4993 44.2515H28.5007C27.6705 44.2515 27 43.5787 27 42.7507V38.2507C27 34.9365 29.6865 32.25 33.0007 32.25H48.0015C51.3135 32.25 54 34.9365 54 38.2507V42.7507C54 43.5787 53.3295 44.2515 52.4993 44.2515Z",
    fill: "#F54F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2492 38.25H39.7485C37.2622 38.25 35.2485 36.2362 35.2485 33.75V32.2493L36 29.25H45L45.7492 32.2493V33.75C45.7492 36.2362 43.7355 38.25 41.2492 38.25Z",
    fill: "#F7D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 29.25L35.757 30.222L43.281 37.746C44.7413 37.0012 45.7515 35.5005 45.7515 33.75V32.2493L45 29.25H36Z",
    fill: "#EEAE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 39C36.7785 39 33.75 35.9715 33.75 32.25H35.2507C35.2507 35.1435 37.6065 37.4993 40.5 37.4993C43.3935 37.4993 45.7493 35.1435 45.7493 32.25H47.25C47.25 35.9737 44.2215 39 40.5 39Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 17.2507C43.344 17.2507 42.0007 16.5802 42.0007 15.75C42.0007 16.578 40.6575 17.2507 39.0015 17.2507H36C34.344 17.2507 33.0007 18.594 33.0007 20.25V21.7507V23.2515C33.0007 28.2217 36.3577 32.2515 40.5 32.2515C44.6422 32.2515 47.9992 28.2217 47.9992 23.2515C47.9992 22.9702 47.9992 21.9847 47.9992 21.7507V20.25C47.9992 18.594 46.656 17.2507 45 17.2507Z",
    fill: "#F7D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24.75H9C6.51375 24.75 4.5 22.7362 4.5 20.25V17.2507C4.5 13.9365 7.1865 11.25 10.5007 11.25H18C19.656 11.25 20.9993 12.5933 20.9993 14.2493C21.8272 14.2493 22.5 14.922 22.5 15.75V20.25C22.5 22.7362 20.4862 24.75 18 24.75Z",
    fill: "#A36229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4993 44.2515H1.50075C0.6705 44.2515 0 43.5787 0 42.7507V38.2507C0 34.9365 2.6865 32.25 6.00075 32.25H21.0015C24.3135 32.25 27 34.9365 27 38.2507V42.7507C27 43.5787 26.3295 44.2515 25.4993 44.2515Z",
    fill: "#3B9C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2492 38.25H12.7507C10.2645 38.25 8.25073 36.2362 8.25073 33.75V32.2493L8.99998 29.25H18L18.7492 32.2493V33.75C18.7492 36.2362 16.7355 38.25 14.2492 38.25Z",
    fill: "#F7D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 29.25L8.75702 30.222L16.281 37.746C17.739 37.0012 18.7493 35.5005 18.7493 33.75V32.2493L18 29.25H9.00002Z",
    fill: "#EEAE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 39C9.7785 39 6.75 35.9715 6.75 32.25H8.25075C8.25075 35.1435 10.6065 37.4993 13.5 37.4993C16.3935 37.4993 18.7493 35.1435 18.7493 32.25H20.25C20.25 35.9737 17.2215 39 13.5 39Z",
    fill: "#007A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17.2507C16.344 17.2507 15.0007 16.578 15.0007 15.75C15.0007 16.578 13.6575 17.2507 12.0015 17.2507H8.99998C7.34398 17.2507 6.00073 18.594 6.00073 20.25V21.7507V23.2515C6.00073 28.2217 9.35773 32.2515 13.5 32.2515C17.6422 32.2515 20.9992 28.2217 20.9992 23.2515C20.9992 22.9702 20.9992 21.9847 20.9992 21.7507V20.25C20.9992 18.594 19.656 17.2507 18 17.2507Z",
    fill: "#F7D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 22.5H20.25C16.5218 22.5 13.5 19.4783 13.5 15.75V11.25C13.5 6.27975 17.5297 2.25 22.5 2.25H33.75C36.2362 2.25 38.25 4.26375 38.25 6.75C39.492 6.75 40.5 7.758 40.5 9V15.75C40.5 19.4783 37.4783 22.5 33.75 22.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 51.75H9C7.758 51.75 6.75 50.742 6.75 49.5V42.75C6.75 37.7797 10.7797 33.75 15.75 33.75H38.25C43.2202 33.75 47.25 37.7797 47.25 42.75V49.5C47.25 50.742 46.242 51.75 45 51.75Z",
    fill: "#1EA8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 42.75H25.875C22.1468 42.75 19.125 39.7282 19.125 36V33.75L20.25 29.25H33.75L34.875 33.75V36C34.875 39.7282 31.8532 42.75 28.125 42.75Z",
    fill: "#F7D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 29.25L19.8855 30.708L31.1692 41.9918C33.3585 40.878 34.875 38.6258 34.875 36V33.75L33.75 29.25H20.25Z",
    fill: "#EEAE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 43.875C21.4178 43.875 16.875 39.3322 16.875 33.75H19.125C19.125 38.0925 22.6575 41.625 27 41.625C31.3425 41.625 34.875 38.0925 34.875 33.75H37.125C37.125 39.3322 32.5822 43.875 27 43.875Z",
    fill: "#0071A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 11.25C31.2638 11.25 29.25 10.242 29.25 9C29.25 10.242 27.2362 11.25 24.75 11.25H20.25C17.7638 11.25 15.75 13.2638 15.75 15.75V18V20.25C15.75 27.7065 20.7878 33.75 27 33.75C33.2122 33.75 38.25 27.7065 38.25 20.25C38.25 19.8293 38.25 18.351 38.25 18V15.75C38.25 13.2638 36.2362 11.25 33.75 11.25Z",
    fill: "#FDE3CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4437_7236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLearnersCountIcon);
export default __webpack_public_path__ + "static/media/TotalLearnersCountIcon.1876088683c3cedf3e1fb0c1a3b9f04f.svg";
export { ForwardRef as ReactComponent };